<template>
  <component :is="layoutToUse">
    <LoadingView />
    <RouterView />
  </component>

  <GlobalLoadingOverlay />
</template>

<script setup lang="ts">
import { computed, provide, ref } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import GlobalLoadingOverlay from './components/GlobalLoadingOverlay/GlobalLoadingOverlay.vue'
import { LoadingKey } from './helpers/symbols'
import DefaultLayout from './layouts/DefaultLayout.vue'
import LoadingView from './views/LoadingView.vue'

const route = useRoute()

const layoutToUse = computed(() => {
  return route.meta.layout || DefaultLayout
})

const isLoading = ref(false)
const toggleLoading = () => {
  isLoading.value = !isLoading.value
}

const setLoading = (value: boolean) => {
  isLoading.value = value
}

provide(LoadingKey, {
  get: isLoading,
  toggle: toggleLoading,
  set: setLoading
})
</script>
